import { TFunction } from 'i18next'

export const restrictionLabel = (
  type:
    | { name?: string; descriptions?: Partial<Record<string, string>> }
    | undefined,
  language: string
): string =>
  type?.descriptions?.[language.slice(0, 2)] ??
  type?.descriptions?.en ??
  type?.descriptions?.fr ??
  type?.descriptions?.de ??
  type?.descriptions?.it ??
  type?.name ??
  ''

/**
 * Converts snake_case zone name to camelCase translation key
 */
function snakeToCamelCase(str: string): string {
  return str.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase())
}

/**
 * Translates an RDPPF zone type name to the user's language.
 *
 * Uses the translations from the restrictions namespace for zone type names.
 * The API returns values in snake_case (e.g., 'forest_zone') - this function
 * converts them to camelCase for translation key lookup.
 *
 * @param zoneName - The zone type name from database (snake_case, e.g., 'forest_zone')
 * @param t - The i18next translation function
 * @returns The translated zone name, or the original if no translation exists
 *
 * @example
 * // Translate zone type
 * translateRdppfZoneName('forest_zone', t) // Returns "Zone forestière" in French
 *
 * @example
 * // Graceful fallback for unknown values
 * translateRdppfZoneName('Unknown Zone', t) // Returns "Unknown Zone"
 */
export function translateRdppfZoneName(
  zoneName: string | undefined | null,
  t: TFunction
): string {
  if (!zoneName) return 'N/A'
  const key = snakeToCamelCase(zoneName.toLowerCase())
  return t(`restrictionTypes.${key}`, {
    ns: 'restrictions',
    defaultValue: zoneName,
  })
}
